import { render, staticRenderFns } from "./CampaignTags.vue?vue&type=template&id=806ae8d6&scoped=true"
import script from "./CampaignTags.vue?vue&type=script&lang=js"
export * from "./CampaignTags.vue?vue&type=script&lang=js"
import style0 from "./CampaignTags.vue?vue&type=style&index=0&id=806ae8d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806ae8d6",
  null
  
)

export default component.exports